import * as React from 'react';
import { ControllerContext } from '../utils';
const useVisualizationController = () => React.useContext(ControllerContext);
export default useVisualizationController;
//# sourceMappingURL=useVisualizationController.js.map